import {
  StyleSheet,
} from 'react-native';

export default StyleSheet.create({
  panel_hover: {
    backgroundColor: '#e0e0e0',
  },
  panel: {
    flex: 1,
    flexDirection: 'row',
    padding: 4,
    marginTop: 3,
    marginBottom: 0,
  },
  panelInner: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-around',
    overflow: 'hidden',
  },
  panelRating: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingBottom: 3,
    overflow: 'hidden',
  },
  imageBlockBackground: {
  },
  imageBlock: {
    borderWidth: 0,
    width: 64,
    minHeight: 64,
    height: 64,
    backgroundColor: '#e0e0e0',
    margin: 0,
    padding: 0,
    marginRight: 6,
  },
  imageBlockNone: {
    borderWidth: 0,
    width: 64,
    minHeight: 64,
    height: 64,
    backgroundColor: '#e0e0e0',
    margin: 0,
    padding: 0,
    marginRight: 6,
  },
  image_img: {
    maxWidth: '100%',
    height: 'auto',
  },
  name: {
    fontSize: 18,
    fontWeight: 'bold',
    maxWidth: '100%',
    overflow: 'hidden',
  },
  review: {
    overflow: 'hidden',
  },
  rating: {
  },
});
